import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import {Button,Tag} from 'antd'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import {withRouter} from 'react-router-dom'
import { ProductTypeSelect } from "../../Sales/Quotes/AddQuote/QuoteForm";
import BoolCell from '../../../elements/Table/Cells/BoolCell'

function List(props) {
  const {list, fetch, fetching, onShow, company, onChangeCompany} = props
  const columns = [
    {
      Header: 'ID',
      accessor: '_id',
      width: 200,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Code',
      accessor: 'code',
      width: 150,
      Cell: ({value, original}) => (
        <a onClick={() => onShow(original, 'edit')}>{value}</a>
      ),
    },
    {
      Header: 'Type',
      accessor: 'type',
      width: 180,
      /*Cell: ({ value }) => {
        return value ? value.map(t => <Tag color={'#108ee9'}>{t}</Tag>) : value
      },*/
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Category',
      accessor: 'category.name',
      width: 180,
    },
    {
      Header: 'Group',
      accessor: 'group.name',
      width: 180
    },
    {Header: 'Name', accessor: 'name'},
    {
      Header: 'Company',
      accessor: 'company.fn',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Currency',
      accessor: 'currency',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Description',
      accessor: 'description',
      hideable: true,
      hideDefault: true,
    },

    {Header: 'Tag', accessor: 'tag', hideable: true, hideDefault: true},
    {
      Header: 'For Sale',
      accessor: 'isForSale',
      Cell: BoolCell,
      width: 100,
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'Stocked',
      accessor: 'isStocked',
      Cell: BoolCell,
      width: 100,
      hideable: true,
      hideDefault: false
    },
    {Header: 'Status', accessor: 'status', Cell: StatusCell, width: 100,},
    {Header: 'State', accessor: 'state', Cell: StatusCell, width: 100,},
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <Button type={'primary'} size="small" icon={'plus'} onClick={onShow}>
          New{' '}
        </Button>
      )}
      columns={columns}
      ExtraOptionsButtons={() => (
        <>
          <OrganisationsSelect
            value={company}
            onChange={onChangeCompany}
            placeholder={'Filter by a company'}
            size={'small'}
            style={{width: '350px', paddingRight: 20, float: 'right'}}
          />
          <ProductTypeSelect
            //value={activity}
            //onChange={onChangeActivity}
            placeholder={'Filter by Activity'}
            size={'small'}
            style={{width: 200, paddingRight: 20, float: 'right'}}
          />
        </>
      )}
      defaultSorted={[
        {
          id: '_key',
          desc: false,
        },
      ]}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default withRouter(List)
